import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";
import { useUser } from "../data/user";
import { useDriver } from "../data/driver";

export function DriverErrorView() {
  const { resetError } = useDriver();
  const { logout } = useUser();

  return (
    <div className="h-screen w-full flex flex-col items-center justify-center text-center px-6">
      <div className="flex flex-col items-center">
        <AlertCircle className="w-12 h-12 text-danger mb-4" strokeWidth={2.5} />
        <p className="font-semibold text-xl mb-2">Ein Fehler ist aufgetreten</p>
        <p className="text-md text-slate-400 leading-6">
          Der Account mit dem du dich eingeloggt hast ist kein Fahrer-Account.
          Bitte logge dich aus und logge dich mit einem Fahrer-Account ein.
        </p>
      </div>
      <Button
        onClick={() => {
          logout();
          resetError();
        }}
        className="mt-8"
        variant="destructive"
      >
        Abmelden
      </Button>
    </div>
  );
}
